<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option
                  v-for="item in tenantList"
                  :key="item.tenantId"
                  :value="item.tenantId"
                >
                  {{
                  item.tenantName
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="水表编号">
              <a-input v-model="query.appearanceNo" placeholder="请输入水表编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="分类编码">
              <a-input v-model="query.classNo" placeholder="请输入分类编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="水表口径">
              <a-input v-model="query.diameter" placeholder="请输入水表口径" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="状态">
              <a-select placeholder="请选择状态" default-value v-model="query.status" allow-clear>
                <a-select-option :key="0">在线</a-select-option>
                <a-select-option :key="1">库存</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="18" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button
                type="primary"
                style="margin-left: 8px"
                @click="addOrUpdateHandle()"
                v-action:add
              >新增</a-button>

              <a-button
                type="danger"
                style="margin-left: 8px"
                @click="deleteSelectRow()"
                v-action:del
              >删除</a-button>
              <a-button
                style="margin-left: 8px"
                @click="exportHandle()"
                type="primary"
                v-action:export
              >导出</a-button>
              <a-button
                type="primary"
                style="margin-left: 8px"
                @click="downloadTemplate({ execlForm: true })"
                v-action:import
              >下载模板</a-button>
              <a-upload
                name="file"
                :multiple="false"
                @change="changeFile"
                :file-list="fileList"
                :customRequest="customRequest"
              >
                <a-button
                  style="margin-left: 8px"
                  type="primary"
                  :loading="importLoading"
                  v-action:import
                >导入</a-button>
              </a-upload>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      size="middle"
      rowKey="id"
      :scroll="{ x: 2100 }"
      bordered
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <a-tag color="blue" slot="status" slot-scope="text">{{ text ? 'yes' : 'NO' }}</a-tag>
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
      <template slot="statusAction" slot-scope="text">
        <a-tag v-if="text==0" color="rgb(50, 205, 50)">在线</a-tag>
        <a-tag v-if="text==1" color="#1890ff">库存</a-tag>
      </template>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
          <a-radio-group
            v-decorator="['status', { rules: [{ required: true, message: '请选择状态' }] }]"
          >
            <a-radio :value="0">在线</a-radio>
            <a-radio :value="1">库存</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="远传表编号" hasFeedback>
          <!-- :disabled="!this.$store.state.user.info.systemAdmin && this.isUpdate" -->
          <a-input
            placeholder="远传表编号"
            v-decorator="['appearanceNo', { rules: [{ required: true, message: '请输入远传表编号' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌" hasFeedback>
          <a-input
            placeholder="品牌"
            v-decorator="['brand', { rules: [{required: true, message: '请输入品牌' }] }]"
          />
        </a-form-item>
            <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="口径"
          hasFeedback
        >
          <a-input
            placeholder="口径"
            v-decorator="['diameter', { rules: [{required: true, message: '请输入正确口径' }] }]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status')===0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="分类编码"
          hasFeedback
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status')===0"
            placeholder="分类编码"
            v-decorator="['classNo', { rules: [{ required: true, message: '请输入分类编码' }] }]"
          />
        </a-form-item>


        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status')===0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="地址"
          hasFeedback
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status')===0"
            placeholder="地址"
            v-decorator="['address', { rules: [{ required: true, message: '请输入地址' }] }]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status')===0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="流出"
          hasFeedback
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status')===0"
            placeholder="流出"
            v-decorator="['outflow', { rules: [{required: true, message: '请输入流出' }] }]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status')===0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="流入"
          hasFeedback
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status')===0"
            placeholder="流入"
            v-decorator="['flowInto', { rules: [{required: true, message: '请输入流入' }] }]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status')===0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="经度"
          hasFeedback
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status')===0"
            placeholder="经度"
            v-decorator="['longitude', { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/,required: true, message: '请输入正确经度' }] }]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status')===0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="纬度"
          hasFeedback
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status')===0"
            placeholder="纬度"
            v-decorator="['latitude', { rules: [{pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入正确纬度' }] }]"
          />
          <!-- ^(-?\d+)(\.\d+)?$  -->
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status')===0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="H高程"
          hasFeedback
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status')===0"
            placeholder="H高程"
            v-decorator="['groundElevation', { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/,required: true, message: '请输入正确H高程' }] }]"
          />
        </a-form-item>

        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status')===0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="埋设时间"
        >
          <a-date-picker
            v-if="addOrUpdateForm.getFieldValue('status')===0"
            placeholder="埋设时间"
            :allowClear="false"
            v-decorator="['deliveryTime', { rules: [{ required: true, message: '请选择埋设时间' }] }]"
            format="YYYY"
            mode="year"
            :open="open"
            @openChange="openChange"
            @panelChange="panelChange"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" hasFeedback>
          <a-input placeholder="备注" v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import moment from 'moment'
import pick from 'lodash.pick'
const STATUS = {
  1: '正常',
  2: '禁用'
}

const columns = [
  {
    title: '分类编码',
    dataIndex: 'classNo'
  },
  {
    title: '水表编号',
    dataIndex: 'appearanceNo'
  },
  {
    title: '口径',
    dataIndex: 'diameter'
  },
  {
    title: '品牌',
    dataIndex: 'brand'
  },
  {
    title: '地址',
    dataIndex: 'address'
  },
  {
    title: '流出',
    dataIndex: 'outflow'
  },
  {
    title: '流入',
    dataIndex: 'flowInto'
  },
  {
    title: '经度',
    dataIndex: 'longitude'
  },
  {
    title: '纬度',
    dataIndex: 'latitude'
  },
  {
    title: 'H高程',
    dataIndex: 'groundElevation'
  },
  {
    title: '埋设时间',
    dataIndex: 'deliveryTime'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'statusAction' }
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    align:'center',
    fixed: 'right',
    width: 100,
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'RemoteWaterMeterList',
  data() {
    return {
      zoneTreeData: [], // 片区选项
      open: false,
      importLoading: false,
      downloadTemplateUrl: 'pipe-network/remote-meters/template/download', // 水表模板
      downloadTemplateName: '考核流量计导入模板.xlsx',
      fileList: [],
      exportDataUrl: 'pipe-network/remote-meters/export',
      exportFileName: '考核流量计.xlsx',
      queryUrl: 'pipe-network/remote-meters/page',
      addOrUpdateUrl: 'pipe-network/remote-meters',
      queryOneUrl: 'pipe-network/remote-meters',
      deleteUrl: 'pipe-network/remote-meters',
      downloadUrl: 'pipe-network/remote-meters/export',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      query: {
        classNo: '',
        appearanceNo: '',
        tenantId: this.$store.state.user.info.tenantId,
        diameter: '',
        status: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns
    }
  },
  // filters: {
  //   statusFilter(key) {
  //     return STATUS[key]
  //   },
  //   permissionFilter(key) {
  //     const permission = PERMISSION_ENUM[key]
  //     return permission && permission.label
  //   }
  // },
  created() {
    this.getAllTenant()
    this.getZoneData()
    this.resetList()
  },
  methods: {
    resetList() {
      if (this.query.sysType) {
        let params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    moment,
    addOrUpdateHandle(id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.addOrUpdateForm.setFieldsValue({ status: data.status })
            this.$nextTick(() => {
              
              setTimeout(() => {
                this.addOrUpdateForm.setFieldsValue(
                  pick(
                    data,
                    'appearanceNo',
                    'brand',
                    'classNo',
                    'diameter',
                    'address',
                    'outflow',
                    'flowInto',
                    'longitude',
                    'latitude',
                    'groundElevation',
                    'deliveryTime',
                    'remark',
                  )
                )
              })
            })
          })
          .catch(() => {})
      } else {
        this.addOrUpdateForm.setFieldsValue({ status: 0 })
      }
    },
    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    panelChange(value) {
      this.addOrUpdateForm.setFieldsValue({ deliveryTime: value })
      this.open = false
    },
    openChange(status) {
      this.open = !!status
    },
    historyData() {
      this.$refs.historyModal.show()
    },
    customRequest(data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile(formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/remote-meters/import',
        headers: {},
        params: {},
        data: formData
      })
        .then(response => {
          if (response.code === 0) {
            this.queryList()
            this.$message.success(response.message)
          }
        })
        .catch(function(error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    // downloadTemplate () {
    //   const fileName = 'exl模板'
    // // VUE_APP_API_BASE_URL(this.downloadUrl + '?excelForm=true')
    //   downFile(this.downloadUrl).then((data) => {
    //     
    //     if (!data) {
    //       this.$message.warning('文件下载失败')
    //       return
    //     }
    //     if (typeof window.navigator.msSaveBlob !== 'undefined') {
    //       window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls') // xls
    //     } else {
    //       const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
    //       const link = document.createElement('a')
    //       link.style.display = 'none'
    //       link.href = url
    //       link.setAttribute('download', fileName + '.xls')
    //       document.body.appendChild(link)
    //       link.click()
    //       document.body.removeChild(link) // 下载完成移除元素
    //       window.URL.revokeObjectURL(url) // 释放掉blob对象
    //     }
    //   }).catch(e => {
    //     console.log(e)
    //   })
    // },
    changeFile(info) {
      // 上传文件
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} 上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    handleOk(e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          var params = {
            id: this.currentId,
            ...values
          }
          console.log(params)
          if (params.deliveryTime) {
            typeof params.deliveryTime === 'string' ? '' : (params.deliveryTime = params.deliveryTime.format('YYYY'))
          }

          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then(res => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
